import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ListGroup, Badge } from 'reactstrap';
import { ListGroupItem, Button } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { startCase } from 'lodash';
import { Link } from 'react-router-dom';

import {
  authorizedInstanceNoBase as full,
  authorizedPyPublicInstance as Public,
  useTopics,
  useSubscriptions,
  useQuery,
} from '~/utils';

const Channel = ({ channel, currentTopic }) => {
  const { newMessages } = useTopics(channel.topic.id);
  const { s } = useQuery();

  return (
    <Button color="link" className={`d-flex mt-2 p-0 justify-content-between align-items-center text-${s === channel.category.id ? 'primary' : 'muted'}`} tag={Link} to={`/chat?s=${channel.category.id}`}>
      <span className="ml-4">
        <FontAwesomeIcon icon={channel.type === 'sms' ? 'mobile-alt' : ['far', 'comment']} fixedWidth className="mr-2" size="sm" />
        <span>{startCase(channel.title)}</span>
      </span>
      {(newMessages !== 0 && currentTopic !== channel.topic.id) && (<Badge color="danger" className="rounded-pill ml-2">{newMessages}</Badge>)}
    </Button>
  );
};

Channel.propTypes = {
  channel: PropTypes.shape().isRequired,
  currentTopic: PropTypes.string,
};

Channel.defaultProps = {
  currentTopic: undefined,
};

const Category = ({
  category, currentTopic: t,
}) => {
  const [data, setData] = useState(category);

  useEffect(() => {
    let topic;

    full
      .get(category.relationships.realTimeTopic.related)
      .then(r => r.data.data)
      .then((r) => {
        topic = r;

        return Public
          .get(`/patient/${r.attributes.subjectUid}`);
      })
      .then(r => r.data.data)
      .then(r => full
        .get(r.relationships.person.related))
      .then(r => r.data.data)
      .then((r) => {
        setData({
          category,
          patient: r,
          channels: [{
            title: 'everyone',
            topic,
            category,
          }],
        });
      });
  }, []);

  return (
    <ListGroupItem>
      <div className="d-flex justify-content-between align-items-center">
        {data.patient && data.patient.attributes && (`${data.patient.attributes.lastName}, ${data.patient.attributes.firstName}`)}

        <FontAwesomeIcon icon="info-circle" fixedWidth className="text-tertiary" />
      </div>

      {data.channels && data.channels.map(channel =>
        <Channel key={channel.topic.id} channel={channel} currentTopic={t} />)}
    </ListGroupItem>
  );
};

Category.propTypes = {
  category: PropTypes.shape().isRequired,
  currentTopic: PropTypes.string,
};

Category.defaultProps = {
  currentTopic: undefined,
};

const CategoryList = ({ currentTopic }) => {
  const subscriptions = useSubscriptions();

  return (
    <ListGroup>
      {subscriptions.map(category => (
        <Category
          key={category.id}
          category={category}
          currentTopic={currentTopic}
        />))}
    </ListGroup>
  );
};

CategoryList.propTypes = {
  currentTopic: PropTypes.string,
};

CategoryList.defaultProps = {
  currentTopic: undefined,
};

export default CategoryList;
